// import { normal } from 'jstat';

const getSexLabel = strResp => {
  const str = `${strResp}`; // force string;
  switch (str) {
    case '1':
      return 'Masculino';
    case '2':
      return 'Femenino';
    case '3':
      return 'Prefiero no decir';
    default:
      return 'Otro';
  }
};

let selectFieldsFromObject = (fields, object) => {
  return fields.reduce((acc, curr) => {
    return { ...acc, [curr]: object[curr] };
  }, {});
};

// let arrayFromObject = object => {
//   const fields = Object.keys(object);
//   return fields.map(field => ({ [field]: object[field] }));
// };

let getSumFomValues = (values = []) => {
  const sum = values
    .filter(Boolean)
    .reduce((acc, curr) => acc + parseFloat(curr), 0);
  return sum;
};

let getMeanFromValues = (values = []) => {
  const sum = getSumFomValues(values);
  const mean = sum / values.length;
  return mean;
};

let getMeanFromFields = (fields, object) => {
  const values = fields.map(field => {
    return parseInt(object[field]);
  });
  const mean = getMeanFromValues(values);
  return mean;
};

let calculateAgeFromBirthday = birthDate => {
  // date comes as "2001-01-02" (year-month-day) from date input
  return Math.floor((new Date() - new Date(birthDate).getTime()) / 3.15576e10);
  // https://stackoverflow.com/questions/4060004/calculate-age-given-the-birth-date-in-the-format-yyyymmdd
};

// let greaterThanZero = val => {
//   return val >= 0 ? val : 0;
// };

const getResults = data => {
  const workingData = { ...data };
  const workingKeys = Object.keys(workingData);
  console.log({ workingData });

  const baseInfo = selectFieldsFromObject(
    [
      'school',
      'grade',
      'name',
      'lastname',
      'email',
      'RUT',
      'BIRTH',
      'SEX',
      'updatedat',
      'TOP_DIM_1',
      'TOP_DIM_2'
    ],
    workingData
  );
  const age = calculateAgeFromBirthday(baseInfo.BIRTH); // "07-19-19"

  const means = {
    HABILIDADES: getMeanFromFields(
      ['ABIL_01', 'ABIL_02', 'ABIL_03', 'ABIL_04', 'ABIL_05', 'ABIL_06'],
      workingData
    ),
    IATA_CON: getMeanFromFields(
      ['IATA_01', 'IATA_02', 'IATA_03', 'IATA_04', 'IATA_05'],
      workingData
    ),
    IATA_REN: getMeanFromFields(
      ['IATA_06', 'IATA_07', 'IATA_08', 'IATA_09', 'IATA_10', 'IATA_11'],
      workingData
    ),
    RECTR_ESP: getMeanFromFields(
      ['RECTR_01', 'RECTR_02', 'RECTR_03', 'RECTR_04'],
      workingData
    ),
    RECTR_AUT: getMeanFromFields(
      ['RECTR_05', 'RECTR_06', 'RECTR_07', 'RECTR_08'],
      workingData
    ),
    RECTR_OPT: getMeanFromFields(
      ['RECTR_09', 'RECTR_10', 'RECTR_11', 'RECTR_12'],
      workingData
    ),
    RECTR_RES: getMeanFromFields(
      ['RECTR_13', 'RECTR_14', 'RECTR_15', 'RECTR_16'],
      workingData
    )
  };

  means.IATA = getMeanFromValues([means.IATA_CON, means.IATA_REN]);
  means.RECTR = getMeanFromValues([
    means.RECTR_ESP,
    means.RECTR_AUT,
    means.RECTR_OPT,
    means.RECTR_RES
  ]);

  // new Estilo aprendizaje scales
  const EP_ESC_KEYS = workingKeys.filter(field => field.startsWith('EP_'));
  const ES_ESC_KEYS = workingKeys.filter(field => field.startsWith('ES_'));
  const EL_ESC_KEYS = workingKeys.filter(field => field.startsWith('EL_'));
  // sub-scales
  const MA_SUB_KEYS = workingKeys.filter(field => field.includes('_MA_'));
  const ES_SUB_KEYS = workingKeys.filter(field => field.includes('_ES_'));
  const ML_SUB_KEYS = workingKeys.filter(field => field.includes('_ML_'));
  const AP_SUB_KEYS = workingKeys.filter(field => field.includes('_AP_'));
  const MS_SUB_KEYS = workingKeys.filter(field => field.includes('_MS_'));
  const EL_SUB_KEYS = workingKeys.filter(field => field.includes('_EL_'));

  // scales sums and averages
  const EP_ESC_SUM = getSumFomValues(
    Object.values(selectFieldsFromObject(EP_ESC_KEYS, workingData))
  );
  const ES_ESC_SUM = getSumFomValues(
    Object.values(selectFieldsFromObject(ES_ESC_KEYS, workingData))
  );
  const EL_ESC_SUM = getSumFomValues(
    Object.values(selectFieldsFromObject(EL_ESC_KEYS, workingData))
  );

  const EP_ESC_MEAN = getMeanFromFields(EP_ESC_KEYS, workingData);
  const ES_ESC_MEAN = getMeanFromFields(ES_ESC_KEYS, workingData);
  const EL_ESC_MEAN = getMeanFromFields(EL_ESC_KEYS, workingData);

  // sub-scales sums and averages
  const MA_SUB_SUM = getSumFomValues(
    Object.values(selectFieldsFromObject(MA_SUB_KEYS, workingData))
  );
  const ES_SUB_SUM = getSumFomValues(
    Object.values(selectFieldsFromObject(ES_SUB_KEYS, workingData))
  );
  const ML_SUB_SUM = getSumFomValues(
    Object.values(selectFieldsFromObject(ML_SUB_KEYS, workingData))
  );
  const AP_SUB_SUM = getSumFomValues(
    Object.values(selectFieldsFromObject(AP_SUB_KEYS, workingData))
  );
  const MS_SUB_SUM = getSumFomValues(
    Object.values(selectFieldsFromObject(MS_SUB_KEYS, workingData))
  );
  const EL_SUB_SUM = getSumFomValues(
    Object.values(selectFieldsFromObject(EL_SUB_KEYS, workingData))
  );

  const MA_SUB_MEAN = getMeanFromFields(MA_SUB_KEYS, workingData);
  const ES_SUB_MEAN = getMeanFromFields(ES_SUB_KEYS, workingData);
  const ML_SUB_MEAN = getMeanFromFields(ML_SUB_KEYS, workingData);
  const AP_SUB_MEAN = getMeanFromFields(AP_SUB_KEYS, workingData);
  const MS_SUB_MEAN = getMeanFromFields(MS_SUB_KEYS, workingData);
  const EL_SUB_MEAN = getMeanFromFields(EL_SUB_KEYS, workingData);

  const estiloScales = {
    EP_ESC_SUM,
    ES_ESC_SUM,
    EL_ESC_SUM,
    EP_ESC_MEAN,
    ES_ESC_MEAN,
    EL_ESC_MEAN,
    //
    MA_SUB_SUM,
    ES_SUB_SUM,
    ML_SUB_SUM,
    AP_SUB_SUM,
    MS_SUB_SUM,
    EL_SUB_SUM,
    MA_SUB_MEAN,
    ES_SUB_MEAN,
    ML_SUB_MEAN,
    AP_SUB_MEAN,
    MS_SUB_MEAN,
    EL_SUB_MEAN
  };

  return {
    ...baseInfo,
    ...workingData,
    SEX: getSexLabel(workingData.SEX),
    GENERO: getSexLabel(workingData.SEX),
    age,
    ...means,
    ...estiloScales
  };
};

export default getResults;
